import type { ProductVersionFormat } from '../../model/model.ts'

export const rcpaxaProductName = 'product-fr-rcp-axa'
export type RcpaxaProductName = typeof rcpaxaProductName

type RcpaxaProductVersionFormat = ProductVersionFormat<'fr-rcp-axa'>

export const rcpaxaProductVersions = [
  /**
   * Initial version
   */
  'product-fr-rcp-axa-1.0.0-2025-12-22',
  /**
   * Require annual payment for an extra set of activities
   * from this version onwards. All other things are
   * the same as 1.0.0.
   */
  'product-fr-rcp-axa-1.1.0-2026-07-14',
] as const satisfies RcpaxaProductVersionFormat[]

export type RcpaxaProductVersion = (typeof rcpaxaProductVersions)[number]

export const rcpaxa_V1_0_0_StaticFilesIds = [
  'rcpaxa-v1_0_0-com-general-terms',
  'rcpaxa-v1_0_0-com-ipid',
  'rcpaxa-v1_0_0-services-general-terms',
  'rcpaxa-v1_0_0-services-ipid',
] as const

export const allRcpaxaStaticFilesIds = [...rcpaxa_V1_0_0_StaticFilesIds] as const

export type RcpaxaStaticFilesId = (typeof allRcpaxaStaticFilesIds)[number]

export const allRcpaxaStaticFilesReferences = {
  'rcpaxa-v1_0_0-com-general-terms': '« CONDITIONS GÉNÉRALES - RESPONSABILITÉ CIVILE PROFESSIONNELLE - COMMERCE »',
  'rcpaxa-v1_0_0-com-ipid':
    "« DOCUMENT D'INFORMATION SUR LE PRODUIT D'ASSURANCE - RESPONSABILITÉ CIVILE PROFESSIONNELLE - COMMERCE »",
  'rcpaxa-v1_0_0-services-general-terms': '« CONDITIONS GÉNÉRALES - RESPONSABILITÉ CIVILE PROFESSIONNELLE - SERVICES »',
  'rcpaxa-v1_0_0-services-ipid':
    "« DOCUMENT D'INFORMATION SUR LE PRODUIT D'ASSURANCE - RESPONSABILITÉ CIVILE PROFESSIONNELLE - SERVICES »",
} as const satisfies Record<RcpaxaStaticFilesId, string>

export const rcpaxaStaticFilesNameByStaticFileId = {
  'rcpaxa-v1_0_0-com-general-terms': 'Conditions générales – RCP Commerce',
  'rcpaxa-v1_0_0-com-ipid': 'IPID RCP Commerce',
  'rcpaxa-v1_0_0-services-general-terms': 'Conditions générales – RCP Prestataires de services',
  'rcpaxa-v1_0_0-services-ipid': 'IPID RCP Prestataires de services',
} as const satisfies Record<RcpaxaStaticFilesId, string>

export const rcpaxaStaticFilesIdsByProductVersion = {
  'product-fr-rcp-axa-1.0.0-2025-12-22': rcpaxa_V1_0_0_StaticFilesIds,
  'product-fr-rcp-axa-1.1.0-2026-07-14': rcpaxa_V1_0_0_StaticFilesIds,
} as const satisfies Record<RcpaxaProductVersion, readonly RcpaxaStaticFilesId[]>
